import type { CatalogItem, CatalogItemInput } from '~/api/types'

// 카탈로그 항목 편집기에서 공유하는 상수·정규화·타입. 동작 변경 없이 추출했다.

// 선택지. 빈 라벨('(없음)')은 빈 문자열을 보낸다.
export const CLASSIFICATION_OPTIONS = [
    { value: '선행요건', label: '선행요건' },
    { value: 'HACCP관리', label: 'HACCP관리' },
]
export const SCALE_OPTIONS = [
    { value: '일반', label: '일반' },
    { value: '소규모', label: '소규모' },
]
export const ASSESSMENT_TYPE_OPTIONS = [
    { value: '', label: '(없음)' },
    { value: '인증', label: '인증' },
    { value: '정기', label: '정기' },
]
export const DATA_TYPE_OPTIONS = [
    { value: '', label: '(없음)' },
    { value: '정량', label: '정량' },
    { value: '정성', label: '정성' },
]

// 분리 내용(평가 기준·내용) 필드. 분류에 따라 의미 있는 필드만 노출한다.
// 선행요건: 기준·관리·현장·지도관 고려사항·기타. HACCP관리: 세부항목·지도관 고려사항·기타.
export type CriteriaKey =
    | 'criteriaStandard'
    | 'criteriaManagement'
    | 'criteriaOnsite'
    | 'inspectorNotes'
    | 'referenceNotes'
    | 'haccpDetail'
export const CRITERIA_LABELS: Record<CriteriaKey, string> = {
    criteriaStandard: '기준',
    criteriaManagement: '관리',
    criteriaOnsite: '현장',
    haccpDetail: '세부항목',
    inspectorNotes: '지도관 고려사항',
    referenceNotes: '기타(예시·근거)',
}
export function CRITERIA_FIELDS_BY_CLASSIFICATION(classification: string) {
    const keys: CriteriaKey[] =
        classification === 'HACCP관리'
            ? ['haccpDetail', 'inspectorNotes', 'referenceNotes']
            : [
                  'criteriaStandard',
                  'criteriaManagement',
                  'criteriaOnsite',
                  'inspectorNotes',
                  'referenceNotes',
              ]
    return keys.map((key) => ({ key, label: CRITERIA_LABELS[key] }))
}

// 빈 폼(새 항목 추가).
export const EMPTY: CatalogItemInput = {
    part: '',
    classification: '선행요건',
    assessmentType: '',
    industry: '',
    scale: '일반',
    majorCategory: '',
    middleCategory: '',
    itemNumber: '',
    title: '',
    maxScore: null,
    scoringScale: '',
    guidance: '',
    dataType: '',
    scoringLogic: '',
    isDeterministic: false,
    criteriaStandard: '',
    criteriaManagement: '',
    criteriaOnsite: '',
    inspectorNotes: '',
    referenceNotes: '',
    haccpDetail: '',
}

// 기존 항목 → 편집 폼 입력값으로 정규화.
export function toInput(item: CatalogItem): CatalogItemInput {
    return {
        part: item.part ?? '',
        classification: item.classification ?? '',
        assessmentType: item.assessmentType ?? '',
        industry: item.industry ?? '',
        scale: item.scale ?? '',
        majorCategory: item.majorCategory ?? '',
        middleCategory: item.middleCategory ?? '',
        itemNumber: item.itemNumber ?? '',
        title: item.title ?? '',
        maxScore: item.maxScore ?? null,
        scoringScale: item.scoringScale ?? '',
        guidance: item.guidance ?? '',
        dataType: item.dataType ?? '',
        scoringLogic: item.scoringLogic ?? '',
        isDeterministic: item.isDeterministic ?? false,
        criteriaStandard: item.criteriaStandard ?? '',
        criteriaManagement: item.criteriaManagement ?? '',
        criteriaOnsite: item.criteriaOnsite ?? '',
        inspectorNotes: item.inspectorNotes ?? '',
        referenceNotes: item.referenceNotes ?? '',
        haccpDetail: item.haccpDetail ?? '',
    }
}

export type FieldKey = keyof CatalogItemInput

// 하위 폼 컴포넌트가 공유하는 폼 접근 props(상태는 메인이 소유).
export interface SectionProps {
    form: CatalogItemInput
    set: <K extends FieldKey>(key: K, value: CatalogItemInput[K]) => void
    isDirty: (key: FieldKey) => boolean
}
